import { Box } from "../../box";
import { forwardRef } from "react";
import { FormContext } from "./FormContext";
import { cssModule, mergeProps } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "form";
export function InnerForm(props) {
  const {
    as = DefaultElement,
    children,
    disabled,
    fluid,
    forwardedRef,
    ...rest
  } = props;
  const fluidValue = useResponsiveValue(fluid);
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-form", fluidValue && "fluid"),
      ref: forwardedRef
    }),
    children: /*#__PURE__*/_jsx(FormContext.Provider, {
      value: {
        disabled,
        fluid: fluidValue
      },
      children: children
    })
  });
}
InnerForm.defaultElement = DefaultElement;
export const Form = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerForm, { ...props,
  forwardedRef: ref
}));